var _g, _path, _g2, _path2, _path3, _path4, _ellipse, _path5, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "level-up",
    xmlns: "http://www.w3.org/2000/svg",
    width: 160.357,
    height: 160.357,
    viewBox: "0 0 160.357 160.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69815",
    "data-name": "Group 69815",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89220",
    "data-name": "Path 89220",
    d: "M80.179,0l26.152,55.722L80.179,109.933H49.272a16.719,16.719,0,0,1-16.7-16.7V76.521a7.312,7.312,0,0,0-7.3-7.3H16.7A16.719,16.719,0,0,1,0,52.517V16.7A16.719,16.719,0,0,1,16.7,0Z",
    transform: "translate(0 0)",
    fill: "#ffa63f"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_89221",
    "data-name": "Path 89221",
    d: "M336.179,16.7V52.517a16.719,16.719,0,0,1-16.7,16.7H310.91a7.312,7.312,0,0,0-7.3,7.3V93.233a16.719,16.719,0,0,1-16.7,16.7H256V0h63.479A16.719,16.719,0,0,1,336.179,16.7Z",
    transform: "translate(-175.821 0)",
    fill: "#ffa63f"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_69817",
    "data-name": "Group 69817",
    transform: "translate(20.301 17.321)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89222",
    "data-name": "Path 89222",
    d: "M77.823,83.86H77.8c-2.333.013-4.841.022-6.721.024V58.828a3.132,3.132,0,0,0-6.264,0V86.992a3.132,3.132,0,0,0,2.6,3.087,26.3,26.3,0,0,0,3.484.07c1.5,0,3.7-.008,6.933-.026a3.132,3.132,0,0,0-.017-6.264Z",
    transform: "translate(-64.82 -55.574)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89223",
    "data-name": "Path 89223",
    d: "M408.65,83.469c-2.333.013-4.841.022-6.721.024V58.437a3.132,3.132,0,1,0-6.264,0V86.6a3.132,3.132,0,0,0,2.6,3.087,26.28,26.28,0,0,0,3.482.07c1.5,0,3.7-.008,6.934-.026a3.132,3.132,0,1,0-.035-6.264Z",
    transform: "translate(-292.045 -55.305)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89224",
    "data-name": "Path 89224",
    d: "M226.8,78.619l2.644,5.124-2.644,6.4a3.761,3.761,0,0,1-3.5-2.506l-9.647-27.784a3.133,3.133,0,0,1,5.919-2.055Z",
    transform: "translate(-166.923 -55.573)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89225",
    "data-name": "Path 89225",
    d: "M154.447,87.016a3.132,3.132,0,0,0-3.132-3.132H142.57v-7.83h7.869a3.132,3.132,0,0,0,0-6.264H142.57V61.96h8.745a3.132,3.132,0,0,0,0-6.264H139.438a3.132,3.132,0,0,0-3.132,3.132V87.016a3.132,3.132,0,0,0,3.132,3.132h11.877A3.132,3.132,0,0,0,154.447,87.016Z",
    transform: "translate(-113.917 -55.574)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89226",
    "data-name": "Path 89226",
    d: "M333.315,61.96a3.132,3.132,0,0,0,0-6.264H321.438a3.132,3.132,0,0,0-3.132,3.132V87.016a3.132,3.132,0,0,0,3.132,3.132h11.877a3.132,3.132,0,0,0,0-6.264H324.57v-7.83h7.869a3.132,3.132,0,1,0,0-6.264H324.57V61.96Z",
    transform: "translate(-238.915 -55.574)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89227",
    "data-name": "Path 89227",
    d: "M192.082,185.7a3.132,3.132,0,0,0-3.132,3.132V208.2c0,1.463-.408,3.347-3.589,4.949a7.116,7.116,0,0,1-3.232.731h-.011a6.347,6.347,0,0,1-3.514-.993c-2.114-1.351-2.976-2.7-2.976-4.666v-19.4a3.132,3.132,0,0,0-6.264,0v19.4c0,4.169,1.919,7.422,5.868,9.945a12.6,12.6,0,0,0,6.878,1.979h.02a13.316,13.316,0,0,0,6.049-1.4c5.815-2.929,7.035-7.35,7.035-10.544V188.828a3.131,3.131,0,0,0-3.132-3.132Z",
    transform: "translate(-136.621 -144.858)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69816",
    "data-name": "Group 69816",
    transform: "translate(59.88 0.173)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89228",
    "data-name": "Path 89228",
    d: "M282.66,185.695h-7.849a3.154,3.154,0,0,0-3.132,3.132v28.188a3.132,3.132,0,1,0,6.264,0v-9.129c1.679-.009,3.635-.018,4.717-.018a11.088,11.088,0,1,0,0-22.173Zm0,15.909c-1.078,0-3.008.009-4.68.018-.009-1.726-.018-3.738-.018-4.84,0-.938-.005-3.021-.01-4.823h4.707a4.825,4.825,0,1,1,0,9.645Z",
    transform: "translate(-266.771 -145.03)",
    fill: "#023aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89229",
    "data-name": "Path 89229",
    d: "M268.842,59.977l-9.2,27.705a3.781,3.781,0,0,1-3.549,2.578h-.025a.3.3,0,0,1-.053,0V78.732L262.9,58a3.132,3.132,0,0,1,5.945,1.973Z",
    transform: "translate(-256.01 -55.858)",
    fill: "#023aff"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89230",
    "data-name": "Path 89230",
    d: "M157.113,382.6a4.733,4.733,0,0,0-6.645,0l-10.9,10.9a4.7,4.7,0,0,0,6.644,6.644l2.883-2.882v20.232a4.7,4.7,0,0,0,9.4,0V397.261l2.883,2.882a4.7,4.7,0,0,0,6.644-6.644Z",
    transform: "translate(-94.909 -261.833)",
    fill: "#4de1ff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89231",
    "data-name": "Path 89231",
    d: "M304.015,393.5l-10.9-10.9a4.73,4.73,0,0,0-6.645,0l-10.9,10.9a4.7,4.7,0,0,0,6.644,6.644l2.882-2.882v20.231a4.7,4.7,0,0,0,9.4,0V397.26l2.882,2.882a4.7,4.7,0,0,0,6.644-6.644Z",
    transform: "translate(-188.315 -261.832)",
    fill: "#3bf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89232",
    "data-name": "Path 89232",
    d: "M455.792,317.926h-2.349V313.7a4.7,4.7,0,0,0-9.4,0v4.228H441.7a4.7,4.7,0,0,0,0,9.4h2.349v4.228a4.7,4.7,0,0,0,9.4,0v-4.228h2.349a4.7,4.7,0,1,0,0-9.4Z",
    transform: "translate(-300.132 -212.222)",
    fill: "#ffa63f"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3032",
    "data-name": "Ellipse 3032",
    cx: 5.012,
    cy: 4.511,
    rx: 5.012,
    ry: 4.511,
    transform: "translate(137.319 79.176)",
    fill: "#ffe13f"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_89233",
    "data-name": "Path 89233",
    d: "M4.7,317.926H7.047V313.7a4.7,4.7,0,0,1,9.4,0v4.228h2.349a4.7,4.7,0,1,1,0,9.4H16.443v4.228a4.7,4.7,0,0,1-9.4,0v-4.228H4.7a4.7,4.7,0,1,1,0-9.4Z",
    transform: "translate(0 -212.222)",
    fill: "#ffa63f"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_3033",
    "data-name": "Ellipse 3033",
    cx: 5.012,
    cy: 4.511,
    rx: 5.012,
    ry: 4.511,
    transform: "translate(13.014 79.176)",
    fill: "#ffe13f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusAssigned);
export default __webpack_public_path__ + "static/media/status-assigned.4aa414d137c551707c9e5e7bd793f19c.svg";
export { ForwardRef as ReactComponent };